import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Typography, Box } from '@mui/material';
import {
  LoginContainer,
  LoginImageContainer,
  LoginForm,
  LoginImage,
  LoginButton
} from '../styles/Login';
import LoginImageSrc from '../assets/images/login/login-image.png';

const Login = ({ onLoginSuccess }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleLogin = async () => {
    const { username, password } = credentials;

    if (!username || !password) {
      return setErrorMessage('Please enter both username and password');
    }

    try {
      const response = await axios.post('http://localhost:8000/token', 
        { username, password },
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );

      if (response.status === 200) {
        localStorage.setItem('token', response.data.access_token);
        onLoginSuccess();
        setErrorMessage('');
      }
    } catch (error) {
      const message = error.response?.status === 401 
        ? 'Invalid username or password' 
        : 'An error occurred. Please try again.';
      setErrorMessage(message);
    }
  };

  return (
    <LoginContainer>
      <LoginImageContainer>
        <Box className="login-text-wrapper" sx={{ borderRadius: '15px' }}>
          <Typography variant="h4" className="login-text">
            Sign in and let Genie AI transform your conversations!
          </Typography>
          <LoginImage src={LoginImageSrc} alt="Sign in illustration" />
        </Box>
      </LoginImageContainer>

      <LoginForm>
        <Typography variant="h4" className="login-form-title">
          LOGIN TO YOUR ACCOUNT
        </Typography>
        <Typography variant="body1" className="login-form-subtitle">
          Access your account with your credentials
        </Typography>
        <TextField
          fullWidth
          label="Username"
          variant="outlined"
          margin="normal"
          name="username"
          value={credentials.username}
          onChange={handleChange}
          InputProps={{
            startAdornment: <Box component="span" className="icon">👤</Box>,
          }}
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          variant="outlined"
          margin="normal"
          name="password"
          value={credentials.password}
          onChange={handleChange}
          InputProps={{
            startAdornment: <Box component="span" className="icon">🔒</Box>,
          }}
        />
        {errorMessage && (
          <Typography color="error" variant="body2">
            {errorMessage}
          </Typography>
        )}
        <LoginButton variant="contained" onClick={handleLogin}>
          Login
        </LoginButton>
      </LoginForm>
    </LoginContainer>
  );
};

export default Login;
